__turbopack_context__.v({
  "answer": "_3zMJvq_answer",
  "in": "_3zMJvq_in",
  "question": "_3zMJvq_question",
  "row": "_3zMJvq_row",
});
